(function ($) {
  function getURLParam(oTarget, sVar) {
    return decodeURI(oTarget.search.replace(new RegExp('^(?:.*[&\\?]' + encodeURI(sVar).replace(/[\.\+\*]/g, '\\$&') + '(?:\\=([^&]*))?)?.*$', 'i'), '$1'));
  }

  function cancelAppointment(token, id, callback, errorCallback) {
    var url = 'https://' + window.location.hostname + '/_abapi/api/v1/appointments/' + id,
      params = {
        token: token,
        _method: 'DELETE'
      };

    $.ajax(
      {
        url: url,
        type: 'POST',
        data: params,
        success: function (r) {
          if (typeof callback === 'function') {
            callback(r);
          }
        },

        error: function (err) {
          var r = JSON.parse(err.responseText);

          if (typeof errorCallback === 'function') {
            errorCallback(r);
          }
        }
      }
    );
  }
  Drupal.behaviors.apptBookConfirm = {
    attach: function (context) {
      var loc = window.location,
        apptToken = getURLParam(loc, 'token'),
        apptId = getURLParam(loc, 'appointment_id'),
        $container = $('#appointment-cancelation', context),
        $cMessage = $container.find('.js-cancel-content'),
        $eMessage = $container.find('.js-error-content'),
        $cImage = $container.find('.js-appt-book-cancel-picture'),
        $cContent = $container.find('.js-appt-book-cancel-content');

      $cContent.css('height', $cImage.css('height'));

      function onCancelSuccess() {
        $cMessage.show();
        $eMessage.hide();
      }

      function onCancelError() {
        $eMessage.show();
        $cMessage.hide();
      }

      if (apptToken && apptId) {
        cancelAppointment(apptToken, apptId, onCancelSuccess, onCancelError);
      }
    }
  };
})(jQuery);
